// extracted by mini-css-extract-plugin
export default {"cls1":"xnqFxdxxSV46ADf2Hrpb","cls2":"ZaebRG6GWpm_C_UK9Ls6 xnqFxdxxSV46ADf2Hrpb","bookingAppRedesign":"vs_7IYlkTjI_CVCuyjAp"};